exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3DM7w{position:relative;line-height:40px;list-style:none;font-size:15px;color:#f2f2f2;background-color:#404040;padding:0 15px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3DM7w span{display:block;margin-right:20px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}body.reader-night-mode ._3DM7w{color:#b3b3b3;background-color:#2e2e2e}._3DM7w:hover,.JUBSP{background-color:#666}body.reader-night-mode ._3DM7w:hover,body.reader-night-mode .JUBSP{background-color:#262626}._31PCv{background-color:#666;border-left:3px solid #ec7259;padding-left:12px}body.reader-night-mode ._31PCv{background-color:#262626}._3URX2{padding-bottom:10px;padding-top:10px}.JUBSP{cursor:-webkit-grabbing;cursor:grabbing;-webkit-box-shadow:0 0 4px 2px rgba(0,0,0,.2);box-shadow:0 0 4px 2px rgba(0,0,0,.2);z-index:125;pointer-events:auto!important}._3DM7w ._2VLy-{float:right}", ""]);

// exports
exports.locals = {
	"notebook-item": "_3DM7w",
	"notebook-item-dragging": "JUBSP",
	"notebook-item-active": "_31PCv",
	"notebook-item-drag-on": "_3URX2",
	"dropdown": "_2VLy-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/NotebookList/NotebookItem/NotebookItem.scss
// module id = 5Fs3
// module chunks = 3